import styles from './upload.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useEffect } from 'react';
const Upload = () => {
  useEffect(() => {
    ScrollTrigger.create({
      trigger: `.${styles.svg}`,
      start: 'top 75%',
      onEnter: () => {
        document.querySelector(`.${styles.svg}`).classList.add("active")
    }
    });

    window.addEventListener("load", () => {
        ScrollTrigger.refresh()
    } );
  });
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svg}
    >
      <mask id="uploadMask" maskUnits="userSpaceOnUse" width="112" height="112">
        <rect width="112" height="112" fill="black" />
        <rect x="19" y="19" width="74" height="70" fill="white" />
      </mask>
      <path
        d="M79.5 19.5L79.5 87.5M32.5 19.5L32.5 53.5V87.5M19.5 53.5V87.5H92.5V19.5H19.5V53.5Z"
        stroke="#F8F6EC"
      />
      <g className={styles.pathBox} mask="url(#uploadMask)">
        <path d="M19.5 36.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 36.5H92.5" stroke="#F8F6EC" />
        <path d="M19.5 53.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 53.5H92.5" stroke="#F8F6EC" />
        <path d="M19.5 70.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 70.5H92.5" stroke="#F8F6EC" />
        <path d="M19.5 87.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 87.5H92.5" stroke="#F8F6EC" />
        <path d="M19.5 104.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 104.5H92.5" stroke="#F8F6EC" />
        <path d="M19.5 121.5H32.5" stroke="#F8F6EC" />
        <path d="M79.5 121.5H92.5" stroke="#F8F6EC" />
      </g>

      <g className={styles.youtube}>
        <path
          d="M66 40C66 40 66 36.745 65.543 35.1858C65.292 34.3265 64.55 33.6492 63.605 33.4165C61.896 33 56 33 56 33C56 33 50.107 33 48.395 33.4165C47.454 33.6457 46.711 34.3239 46.457 35.1858C46 36.745 46 40 46 40C46 40 46 43.255 46.457 44.8143C46.708 45.6735 47.45 46.3507 48.395 46.5835C50.107 47 56 47 56 47C56 47 61.896 47 63.605 46.5835C64.546 46.3542 65.289 45.6761 65.543 44.8143C66 43.255 66 40 66 40Z"
          stroke="#F8F6EC"
        />
        <path d="M54 37V43L59 40L54 37Z" stroke="#F8F6EC" />
      </g>

      <g className={styles.arrow}>
        <path
          d="M55.5 65L55.5 105"
          stroke="#F8F6EC"
        />
        <path
          d="M43.5 77L55.5 65L67.5 77"
          stroke="#F8F6EC"
        />
      </g>
    </svg>
  );
};

export default Upload;
